import { Box, Grid, Typography } from "@mui/material";
import { playerTeamLogo } from "../../../../Assets";
import {
  formatToIndianCurrencyWords2,
  teamGradients,
} from "../../../../Utils/helperFunctions";

const TeamSection: React.FC<any> = ({ teamDetails }) => {
  console.log(teamDetails, "teamDetails");
  return (
    <Box height={"fit-content"} mt={"3vw"}>
      <Grid
        container
        sx={{ width: "100%" }}
        columnSpacing={{ md: "1.5vw", xl: "1.5vw" }}
        rowSpacing={{ md: "3vw", xl: "3.5vw" }}
      >
        {teamDetails
          ?.slice()
          .sort((a: any, b: any) => a.Name.localeCompare(b.Name))
          .map((item: any, i: number) => (
            <Grid item key={i} xs={12} sm={6} md={4} lg={3}>
              <TeamCard team={item} />
            </Grid>
          ))}
      </Grid>
    </Box>
  );
};

const TeamCard: React.FC<any> = ({ team }) => {
  console.log(team, "team");

  const players = team?.Player_Registrations__r?.records || [];
  const gradient = teamGradients[team?.Name] || { from: "#1e1e1e", to: "#444" }; // fallback gradient
  const getCategoryCount = (level: string) =>
    players.filter((p: any) => p.Recent_Competitive_Level__c === level).length;

  const totalPlayers = players?.length;
  const remainingFundFormatted = formatToIndianCurrencyWords2(
    team?.Fund_Remaining__c
  );

  return (
    <Box
      sx={{
        position: "relative",
        borderRadius: ".3vw",
        // overflow: "hidden",
        p: "0.6vw",
        display: "flex",
        justifyContent: "center",
        // alignItems: "center",
        background: `linear-gradient(to bottom, ${gradient.from}, ${gradient.to})`,
        height: "fit-content",
        minHeight: "240px",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          zIndex: 3,
          textAlign: "center",
          top: "-2.2vw",
          backgroundColor: "white",
          padding: "15px",
          width: "5vw",
          height: "5vw",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          borderRadius: "5vw",
          overflow: "hidden",
        }}
      >
        <img
          src={
            team?.Name == "Aakash Tigers MWS"
              ? "https://turbostart.blob.core.windows.net/turbostart/48447191083078844-aakashTigers.png"
              : team?.Name == "MSC Maratha Royals"
              ? "https://mcadirectory.blob.core.windows.net/dev/4441894866960012-shivajiParkLions.png"
              : team?.Name == "Triumph Knights Mumbai North East"
              ? "https://mcadirectory.blob.core.windows.net/dev/007792959990218895-triumphKnights.png"
              : team?.Logo_URL__c || playerTeamLogo
          }
          alt="Team Logo"
          width={100}
          height={100}
          style={{
            height: "auto", // roughly h-28
            width: "4.5vw",
            margin: "0 auto",
          }}
        />
      </Box>
      <Box mt={"5vw"} sx={{ textAlign: "center", width: "100%" }}>
        <Typography
          variant="h1"
          sx={{ fontSize: "1.2vw", fontWeight: 600, mb: ".2VW" }}
          color="white"
        >
          Fund remaining
        </Typography>
        <Typography
          variant="h1"
          sx={{ fontSize: "1.4vw", fontWeight: 600 }}
          color="white"
        >
          {remainingFundFormatted}
        </Typography>
        <Grid container spacing={"0.5vw"} mt={"0.2vw"}>
          {[
            {
              label: "Icon",
              count: getCategoryCount("Indian senior team"),
              minPlayerCount: 1,
            },
            {
              label: "Senior",
              count: getCategoryCount(
                "First class, list A, BCCI Senior Men T20"
              ),
              minPlayerCount: 4,
            },
            {
              label: "Emerging",
              count: getCategoryCount(
                "Mumbai age group team (under 23 or under 19)"
              ),
              minPlayerCount: 5,
            },
            {
              label: "Development",
              count: getCategoryCount("Local club team"),
              minPlayerCount: 5,
            },
          ].map((item, index) => (
            <Grid item xs={6} key={index}>
              <Box
                sx={{
                  bgcolor: "#FFFFFF36",
                  padding: "0.3vw 0",
                  width: "100%",
                  color: "#fff",
                  borderRadius: "0.3vw",
                  border: "0.5px solid #EAEAEA",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{ fontSize: "1.1vw", fontWeight: 700, mb: "0.2vw" }}
                  color="white"
                >
                  {item.count}/{item.minPlayerCount}
                </Typography>
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: "1vw",
                    fontWeight: 600,
                    padding: "0.2vw 0",
                    background:
                      "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.30) 50%, rgba(255, 255, 255, 0.00) 100%)",
                  }}
                  color="white"
                >
                  {item.label}
                </Typography>
              </Box>
            </Grid>
          ))}
          <Grid item xs={12}>
            <Box
              sx={{
                bgcolor: "#FFFFFF36",
                padding: "0.3vw 0",
                width: "100%",
                color: "#fff",
                borderRadius: "0.3vw",
                border: "0.5px solid #EAEAEA",
              }}
            >
              <Typography
                variant="h4"
                sx={{ fontSize: "1.1vw", fontWeight: 700, mb: "0.2vw" }}
                color="white"
              >
                {totalPlayers}/18
              </Typography>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "1vw",
                  fontWeight: 600,
                  padding: "0.2vw 0",
                  background:
                    "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.30) 50%, rgba(255, 255, 255, 0.00) 100%)",
                }}
                color="white"
              >
                {/* {item.label} */}
                Total Players
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default TeamSection;
